interface IIntro {
    className?: string;
}

function Intro(props: IIntro) {
    return <div id="main" className={`${props.className} flex flex-col md:flex-row min-h-screen justify-center items-center gap-2`}>
        <img src="/profilepic.jpg" alt="profile-pic" className="rounded-full max-w-full h-auto shadow-lg border-2"/>
        <div className="ml-5 p-2 pb-0 border-l-2 border-five">
            <h1 className="text-4xl lg:text-6xl lg:pb-2 font-bold">Yong Shun Jie</h1>
            <p className="text-xl lg:text-2xl pb-2">Computer / Software Engineer</p>
        </div>
    </div>
}

export default Intro;